import { combineReducers } from "@reduxjs/toolkit";
import { getAllCategoriesReducer, getTopCategoriesReducer } from "./slices";

const categoryReducer = combineReducers({
  allCategories: getAllCategoriesReducer,
  topCategories: getTopCategoriesReducer,
});

export default categoryReducer;
